import request from '@/libs/request'
import { toast } from '../libs/utils'

// 获取预约检查日期列表
export async function getCheckTimeList (params) {
  let data = await request.post('/order/orderCheckOrderInfo/appointmentTimeList', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取预约检查日期列表异常！' })
    return false
  }
}
// 获取检查设备
export async function getCheckDevice (params) {
  let data = await request.post('/bdc/commonMedicalImageCenterDevice/findDeviceCategoryGroup', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取检查设备列表异常' })
    return false
  }
}
// 影像中心列表
export async function getImageCenterList (params) {
  let data = await request.post('/bdc/commonMedicalImageCenter/queryPage', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询影像中心异常' })
    return false
  }
}
// 获取检查分类
export async function getCheckObject (params) {
  let data = await request.post('/bdc/commonHospitalCheckItem/getByDeviceId', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } 
  throw Error(data.message || '获取检查分类异常')
}
// 查看部位详情
export async function getCheckBody (params) {
  let data = await request.post('/bdc/commonHospitalCheckItem/queryBodyItem', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } 
  throw Error(data.message || '获取检查部位异常')
}
// 获取后处理
export async function afterHandle (params) {
  let data = await request.post('/bdc/commonBodyItemCheckBaseElement/findByBodyItemIdAndProcessType', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取后处理异常' })
    return false
  }
}
// 查询耗材详情
export async function getConsumables (params) {
  let data = await request.post('/bdc/commonHospitalCheckItem/getById', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询耗材异常' })
    return false
  }
}
// 新增编辑检查订单
export async function saveNewCheck (params) {
  let data = await request.postJson('/order/orderCheckOrderInfo/saveCheckOrderInfo', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '编辑检查订单异常' })
    return false
  }
}
// 查看检查订单详情
export async function getCheckOrderDetails (params) {
  let data = await request.post('/order/orderCheckOrderInfo/findRisCheckOrder', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查看检查订单详情异常' })
    return false
  }
}
// 查询短信模板
export async function getTemplate (params) {
  let data = await request.post('/order/orderCheckOrderInfo/findOrderCheckNoteTemplate', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询短信模板异常' })
    return false
  }
}
// 查询短信模板
export async function sendMessage (params) {
  let data = await request.post('/order/orderCheckOrderInfo/sendOrderCheckMobileMessage', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  } else {
    toast({ msg: data.message || '发送短信异常' })
    return false
  }
}
// 获取设置检查人列表
export async function getWorkerList (params) {
  let data = await request.post('/order/orderPersonnel/queryOperatorList', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取设置检查人列表异常' })
    return false
  }
}
// 新增检查订单相关的操作人
export async function addSetWorker (params) {
  let data = await request.post('/order/orderPersonnel/addOrderCheckOperator', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '新增检查操作人异常' })
    return false
  }
}
// 呼叫患者
export async function callScanning (params) {
  let data = await request.post('/order/orderCheckOrderInfo/callPatient', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  } else {
    toast({ msg: data.message || '呼叫患者异常' })
    return false
  }
}
// 完成扫描
export async function successScanning (params) {
  let data = await request.post('/order/orderCheckOrderInfo/finishScan', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  } else {
    toast({ msg: data.message || '完成扫描异常' })
    return false
  }
}
// 取消扫描
export async function cancelScanning (params) {
  let data = await request.post('/order/orderCheckOrderInfo/cancelScan', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  } else {
    toast({ msg: data.message || '取消扫描异常' })
    return false
  }
}
// 获取诊断中心列表
export async function getDiagnosedList (params) {
  let data = await request.postJson('/bdc/commonMedicalDiagnoseCenter/findPage', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取诊断中心列表异常' })
    return false
  }
}
// 获取编写医生列表
export async function getWriteDoctorList (params) {
  let data = await request.post('/uac/userInfo/queryUserInfoRole', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取编写医生列表异常' })
    return false
  }
}
// 根据身份证查询患者信息
export async function getPatientInfoByIdNumber (params) {
  let data = await request.post('/pmc/info/finaByIdNumber', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result || {}
  } else {
    toast({ msg: data.message || '查询患者信息异常' })
    return false
  }
}
// 查询快诊订单
export async function getQuickOrderList (params) {
  let data = await request.post('/order/diagOrders/queryPage', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询患者信息异常' })
    return false
  }
}
// 查询快诊订单搜索项目
export async function getQuickOrderItem (params) {
  let data = await request.post('/order/diagCheckProject/query', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询项目异常' })
    return false
  }
}
// 获取后处理标签
export async function getAfterDealList (params) {
  let data = await request.post('/bdc/commonCheckBaseElement/findByProcessType', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取后处理标签异常' })
    return false
  }
}
// 获取耗材列表
export async function getConsumList (params) {
  let data = await request.post('/bdc/commonMedicalImageCenterMaterial/findByMedicalImageCenterId', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取后处理标签异常' })
    return false
  }
}
// 获取快诊医生
export async function getQuickDoctorList (params) {
  let data = await request.postJson('/doctor/info/queryDoctorList', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取快诊医生异常' })
    return false
  }
}
// 护士取消检查
export async function nurseCancelCheck (params) {
  let data = await request.post('/order/orderCheckOrderInfo/cancel', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '取消检查异常' })
    return false
  }
}
// 查询检查设备列表
export async function getAllBodyItem (params) {
  let data = await request.post('/bdc/commonDeviceCategory/findPage', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询检查设备列表异常' })
    return false
  }
}
// 根据手机号码查询患者信息
export async function getPatientMsgForPhone (params) {
  let data = await request.post('/pmc/info/findByMobileAndCustomerChannelIdSort', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '查询患者信息异常' })
    return false
  }
}

// 上传影像
export async function aiUploadImage (params) {
  let data = await request.postFile('/ris/dicom/upload ', params, {}, {requestUpload: 'AI'})
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    return false
  }
}
// 通知影像上传成功
export async function aiUploadImageComplete (params) {
  let data = await request.post('/ris/dicom/complete', params, {}, {requestUpload: 'AI'})
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '通知上传完成异常' })
    return false
  }
}

export async function checkUploadFile(params) {
  let data = await request.postFile('/order/orderCheckOrderInfo/uploadFile', params)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({ msg: data.message || '上传其他文件异常' })
    return false
  }
}

export async function getCheckOrderInfoByOrderCode(params) {
  let data = await request.postFile('/order/orderCheckOrderInfo/findByChildCheckOrderCode', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({ msg: data.message || '获取检查单信息异常' })
    return false
  }
}